export const topVehiclesDataFormatter = (data) => {
    const { topVehicles = [], lastUpdatedUTC = '', } = data || {};
    return {
        chartData: topVehicles.map(({ vin, vehicleYear, vehicleMake, vehicleModel, leadCount, }) => ({
            description: `${vehicleYear} ${vehicleMake} ${vehicleModel}: VIN ${vin}`,
            value: leadCount,
        })),
        lastUpdatedUTC,
    };
};
export default {
    topVehiclesDataFormatter,
};
